import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss']
})
export class RatingComponent implements OnInit, OnChanges {
  @Output() rated = new EventEmitter<number>();

  // Rates values and descriptions.
  rates: number[] = [1, 2, 3, 4, 5];
  ratesDescription: string[] = ['Detestei', 'Não Gostei', 'Razoável', 'Gostei', 'Adorei']

  // Input property to receive initial value from parent component.
  @Input() rate = 0;

  @Input() readOnly = false;

  // Name of current description.
  rateDescription: string;

  // Control of previous rate.
  previousRate: number;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    // When rate change the value, description will be updated.
    if (changes.rate.currentValue !== undefined) {
      this.rateDescription = this.ratesDescription[changes.rate.currentValue - 1];
    }
  }

  setRate(r: number) {
    if (!this.readOnly) {
      this.rate = r
      this.previousRate = undefined
      this.rated.emit(this.rate)
    }
  }

  setTemporaryRate(r: number) {
    if (!this.readOnly) {
      if (this.previousRate === undefined) {
        this.previousRate = this.rate
      }
      this.rate = r
      this.rateDescription = this.ratesDescription[r - 1];
    }
  }

  clearTemporaryRate() {
    if (!this.readOnly) {
      if (this.previousRate !== undefined) {
        this.rate = this.previousRate
        this.rateDescription = this.ratesDescription[this.previousRate - 1];
        this.previousRate = undefined
      }
    }
  }
}
